import React from "react";
import { Button, Radio, Space } from "antd";

export default function StepInterest({ value, onPick, onBack }) {
  return (
    <Space direction="vertical" size={14} style={{ width: "100%" }}>
      <Radio.Group
        value={value}
        onChange={(e) => onPick(e.target.value)}
        style={{ width: "100%" }}
      >
        <Space direction="vertical" size={12} style={{ width: "100%" }}>
          <Radio className="bv-radio" value="armacao">
            Comprar armação nova
          </Radio>
          <Radio className="bv-radio" value="lentes">
            Comprar lentes novas
          </Radio>
          <Radio className="bv-radio" value="oculos_completos">
            Ver promoções de óculos completos
          </Radio>
        </Space>
      </Radio.Group>

      <Button size="large" className="bv-secondary" onClick={onBack}>
        Voltar
      </Button>
    </Space>
  );
}